<template>
  <section class="hero-home-wrapper">
    <transition-group class="hero-home" tag="div" name="fade-down">
      <template v-if="!isLoading">
        <div class="powered-by" key="powered-by">
          Powered by
          <IOdometer :duration="200" class="ranker-votes" :value="currentVotes"></IOdometer>
          Consumer Votes
        </div>
        <div class="subtext" key="subtext">
          Unlock rich psychographic data powered by the self-declared viewing and <br>
          purchase preferences of 90 million <a href="//ranker.com" target="_blank" class="brand-link"><i class="icon ranker-icon"></i> Ranker</a> and <a class="brand-link" href="//watchworthy.app" target="_blank"><i class="icon ww-icon"></i> Watchworthy</a> users
        </div>
        <SearchInput
            key="search"
            class="home-search-input"
            placeholder="Search for any TV show, movie, actor, and more..."
        />
      </template>
    </transition-group>
  </section>
</template>
<script>
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
import SearchInput from '@/components/ui/SearchInput';
import {getTallyVotes} from '@/api/tally';

export default {
  name: 'HeroHome',
  components: {
    IOdometer,
    SearchInput
  },
  data() {
    return {
      isLoading: true,
      dailyVotes: 50000,
      currentVotes: 0, //this will be displayed, this is the number we'll increase
      totalAddedVotesInCycle: 3600, //this is the total votes that will be returned by the API for the speciffic period of time we request
      currentlyAddedVotesInCycle: 0, //count of how many votes we added, has to <= totalAddedVotesInCycle
      cycleLengthInMinutes: 60, //period of time we will be requesting for the api on each call
      votesPer5Seconds: 0, //will calculate how many votes avg we want to be adding every 5 seconds (just as a baseline, actual number will vary)
      addVotesInterval: null,
      jitterConstant: 0, //will contain a number that tells us how much wiggle room we have when randomizing votes added per tick
      currentIntValue: 0 //will hold the number of milliseconds for the next interval we set
    };
  },
  computed: {
    displayCurrentVotes() {
      return new Intl.NumberFormat('en-US').format(this.currentVotes);
    }
  },
  async created() {
    await this.getVotes();
    this.isLoading = false;
    this.votesPer5Seconds = Math.round((this.totalAddedVotesInCycle / this.cycleLengthInMinutes) / 12);
    this.jitterConstant = this.votesPer5Seconds - 2 > 0 ? this.votesPer5Seconds - 2 : this.votesPer5Seconds - 1 > 0 ? this.votesPer5Seconds - 1 : this.votesPer5Seconds;
    this.setRandomInterval();
  },
  beforeDestroy() {
    this.clearVotesInterval();
  },
  methods: {
    async getVotes() {
      try {
        const {totalVotes} = await getTallyVotes({});
        if (totalVotes && this.currentVotes < totalVotes) {
          this.currentVotes = totalVotes;
        }
      }
      catch (e) {
        // fallback: fake increase
        if (this.currentVotes === 0) {
          this.currentVotes = 1212802942;
        } else {
          const min = 12;
          const max = 17;
          const increase = Math.floor(Math.random() * (max - min + 1) + min);
          this.currentVotes += increase;
        }
      }
    },
    async addVotes() {
      /*const jitter = this.generateRandomNumberWithPossibleNegatives(this.jitterConstant);
      let votesToAdd = this.votesPer5Seconds + jitter > 0 ? this.votesPer5Seconds + jitter : this.votesPer5Seconds;
      if (this.totalAddedVotesInCycle > this.currentlyAddedVotesInCycle) {
        if (votesToAdd > (this.totalAddedVotesInCycle - this.currentlyAddedVotesInCycle)) {
          votesToAdd = votesToAdd - (this.totalAddedVotesInCycle - this.currentlyAddedVotesInCycle);
        }
        this.currentlyAddedVotesInCycle = this.currentlyAddedVotesInCycle + votesToAdd;
        this.currentVotes = this.currentVotes + votesToAdd;
        this.clearVotesInterval();
        this.setRandomInterval();
      }
      else {
        this.clearVotesInterval();
      }*/
      await this.getVotes();
      this.clearVotesInterval();
      this.setRandomInterval();
    },
    clearVotesInterval() {
      clearInterval(this.addVotesInterval);
    },
    setRandomInterval() {
      this.currentIntValue = 5000 - this.generateRandomNumberWithPossibleNegatives(999);
      this.addVotesInterval = setInterval(this.addVotes, this.currentIntValue);
    },
    generateRandomNumberWithPossibleNegatives(jitter) {
      return Math.ceil(Math.random() * jitter) * (Math.round(Math.random()) ? 1 : -1);
    }
  }
};
</script>
<style lang="postcss">
.hero-home-wrapper {
  @apply w-full flex justify-center;
  background: #00131D;
  min-height: 443px;

  .hero-home {
    @apply flex flex-col justify-center items-center;
    height: 443px;
    width: 100%;
    background: url('~@/assets/images/hero-background-3x.jpg') no-repeat center center;
    background-size: cover;
  }

  .powered-by {
    @apply text-white flex items-baseline items-center text-right;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 42px;
  }

  .ranker-votes {
    @apply relative flex items-center text-center;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 72px;
    line-height: 84px;
    letter-spacing: -2px;
    margin-right: 8px;
  }

  .odometer-theme-default {
    @apply relative;
  }

  .subtext {
    @apply text-white text-center;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 29px;
    opacity: 0.85;
  }

  .home-search-input {
    margin-top: 90px;
    width: 750px;
    max-width: 85vw;
  }

  @media all and (max-width: 1000px) {
    .powered-by {
      font-size: 30px;
    }

    .ranker-votes {
      font-size: 50px;
      line-height: 56px;
    }

    .subtext {
      font-size: 20px;
    }
  }

  .brand-link {
    @apply inline-flex font-bold items-baseline text-white hover:text-white;

    &:visited, &:hover {
      @apply text-white;
      text-decoration: none;
    }
  }
  .icon {
    @apply inline-flex  items-baseline;

    &.ranker-icon {
      @apply w-7 h-7 mr-1;
      background: url('~@/assets/images/ranker-brand-icon.png') no-repeat center bottom;
      background-size: contain;
    }

    &.ww-icon {
      @apply w-8 h-8 mr-1;
      background: url('~@/assets/images/ww-brand-icon.png') no-repeat center bottom;
      background-size: contain;
    }
  }
}
</style>